export class ExpenseTranslateModel {
    description = {
        en: '',
        de: '',
        fr: '',
        it: '',
    };
}